import React from 'react';
import { Router, Route, browserHistory } from 'react-router';
import Login from '../containers/Login';
import ParkingHome from '../containers/ParkingHome';
import HomePage from '../containers/HomePage';
import OauthCallback from '../containers/OauthCallback';
import SpotConfirmedMessage from '../containers/SpotConfirmedMessage';
import Checkout from '../containers/checkout/index';
import {checkLoggedIn} from '../utils';

const AppRoutes = () => {
  return (
      <Router history={browserHistory}>
        <Route path="/" component={HomePage} />
        <Route path="login" component={Login} />
        <Route exact path="parking" component={ParkingHome} />
        <Route path="parking/:spot_id" component={ParkingHome} />  
        <Route path="checkout" component={Checkout} onEnter={checkLoggedIn} />
        <Route path="confirmation" component={SpotConfirmedMessage} onEnter={checkLoggedIn} />
        <Route path="oauthRedirect" component={OauthCallback} />
        <Route path="*" component={HomePage} />
      </Router>
  );
};

export default AppRoutes;



// WEBPACK FOOTER //
// ./src/components/routes.js